import type { MigratableTemplateContent } from './types';
import { SCHEMA_VERSION } from '../types/template/schema';
import { migratableTemplateContentSchema } from './types';
import { migrateV1ToV2 } from './v1-to-v2';
import { migrateV2ToV3 } from './v2-to-v3';
import { migrateV3ToV4 } from './v3-to-v4';
import { migrateV4ToV5 } from './v4-to-v5';
import { migrateV5ToV6 } from './v5-to-v6';
import { migrateV6ToV7 } from './v6-to-v7';
import { migrateV7ToV8 } from './v7-to-v8';
import { migrateV8ToV9 } from './v8-to-v9';

type Migration = (data: MigratableTemplateContent) => void;

const migrations: Record<string, Migration> = {
  '1': migrateV1ToV2,
  '2': migrateV2ToV3,
  '3': migrateV3ToV4,
  '4': migrateV4ToV5,
  '5': migrateV5ToV6,
  '6': migrateV6ToV7,
  '7': migrateV7ToV8,
  '8': migrateV8ToV9,
};

export function migrateToLatest(
  data: MigratableTemplateContent,
): MigratableTemplateContent;
export function migrateToLatest(data: unknown): unknown;
export function migrateToLatest(data: unknown): unknown {
  const parsed = migratableTemplateContentSchema.safeParse(data);

  if (!parsed.success) {
    // Data doesn't match expected structure — return as-is, let downstream Zod parse handle the error
    return data;
  }

  const cloned = structuredClone(parsed.data);
  let version = cloned.version;
  const maxSteps = Object.keys(migrations).length + 1;
  let steps = 0;

  while (version !== SCHEMA_VERSION) {
    if (steps++ >= maxSteps) {
      throw new Error(
        `Migration stuck: version "${version}" after ${steps} steps (target: "${SCHEMA_VERSION}")`,
      );
    }

    const migrate = migrations[version];

    if (!migrate) {
      // Unknown version — treat as oldest and start from '1'
      console.warn(
        `Unknown schema version "${version}", falling back to v1 migration chain`,
      );
      cloned.version = '1';
      version = '1';
      continue;
    }

    migrate(cloned);
    version = cloned.version;
  }

  return cloned;
}
